import ApiService from "./api.service";

const Holidays = {
  create: async function (data) {
    let response = await ApiService.post("/holidays", data, "Holiday was created");
    return response.data;
  },
  update: async function (holiday_id, data) {
    let response = await ApiService.put("/holidays/" + holiday_id, data, "Holiday profile was updated");
    return response.data;
  },
  delete: async function (holiday_id) {
    await ApiService.delete("/holidays/" + holiday_id, {}, "Holiday was deleted");
    return true;
  },
  getByYear: async function (year) {
    let response = await ApiService.get("/holidays/"+year);
    return response.data.holidays;
  },
};

export default Holidays;